// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1127":"5c713b8ffbb5f4bf","5713":"f755a3b577e6fc0f","6294":"57cb0da95d0342cc"}[chunkId] + ".css";
};